import { useMutation, useQueryClient } from "@tanstack/react-query";

import { upsertMatchesSuspensions } from "@/api/sportEventsNew";
import { RiskQueryKeys } from "@/tanstackQuery/queries/risk";
import type {
  MatchSuspensionsEditorResponse,
  UpsertMatchSuspensionsParams,
} from "@/types/ApiResponses/SportEvent";

export interface SuspendRiskMatchOptions {
  onSuccess?: (
    data: MatchSuspensionsEditorResponse,
    variables: UpsertMatchSuspensionsParams
  ) => void;
  onError?: (error: Error) => void;
}

// The risk page's Bahis switch: a plain manual match suspension (same rows as
// the matches screens), but only the risk-matches list is refreshed. The
// optimistic useUpsertMatchesSuspensions is deliberately NOT reused: it
// patches a positional MatchSuspensions key the risk page never reads.
export const useSuspendRiskMatch = (options?: SuspendRiskMatchOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpsertMatchSuspensionsParams) =>
      upsertMatchesSuspensions(data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Matches] });
      options?.onSuccess?.(data, variables);
    },
    onError: options?.onError,
  });
};
